import { useScanDeviceApiDelete } from '@hooks/api/useScanDeviceApiDelete';
import type { VrsAccount } from 'types/api';

export const useVrsAccountDelete = useScanDeviceApiDelete<VrsAccount>('/vrs-accounts');
